import { Colors } from "../constants/colors";
import { htmlStyles, formStyles } from "./styles";

export default {
  styleOverrides: {
    root: {
      //this overrides the default error styling for text-fields
      "& .Mui-error": {
        color: `${Colors.RED400} !important`,
        "&:after": {
          borderBottomColor: `${Colors.RED400} !important`,
        },
      },
    },
  },
  variants: [
    {
      props: { variant: "filled" },
      style: {
        "& .MuiInputLabel-root": {
          ...formStyles.formElementText,
          "&.Mui-disabled .MuiInputLabel-asterisk": {
            color: Colors.GREY350,
          },
          "&.MuiInputLabel-shrink": {
            fontSize: 12,
          },
          "&.Mui-focused": {
            color: Colors.BLUE400,
            "& .MuiInputLabel-asterisk": {
              color: Colors.BLUE400,
            },
          },
          "& .MuiInputLabel-asterisk": {
            color: Colors.RED400,
          },
        },
        "& .MuiInputBase-input": {
          ...htmlStyles.h6,
        },
      },
    },
    {
      props: { readOnly: true },
      style: {
        "& .MuiInputLabel-root:not(.Mui-error)": {
          color: `${Colors.GREY400} !important`,
        },
        "& .MuiInputBase-root": {
          backgroundColor: `${Colors.WHITE} !important`,
          "&:before": {
            borderColor: Colors.GREY300,
          },
        },
        "& .MuiInputBase-input": {
          color: `${Colors.GREY450} !important`,
          "-webkit-text-fill-color": "unset !important",
        },
      },
    },
    {
      props: { isCopilotField: true },
      style: {
        "& .MuiInputBase-root": {
          "&:before": {
            borderColor: Colors.BLUE400,
          },
          "&:hover": {
            "&:before": {
              borderColor: Colors.BLUE400,
            },
          },
        },
      },
    },
  ],
};
